import { observable, action, runInAction } from 'mobx';

import Service from '@service/index';

const moSkinPdf = observable({
  headerHeight: 60,
  partner: 'smartsalary',
  modules: <any[]>[],
  logo1: '',
  logo2: '',
  hiddenPages: <any[]>[],
  businessPlan: <any>null, // 企业套餐 - 企业VIP套餐
  customReports: <any>null, // 企业套餐 - 定制报告
  goldMember: <any>null, // 企业套餐 - 黄金会员
  priceCount: 0,
  mainColor: '',
  titleCapColor: '',
  counselor: <any>null,
  scripts: <any[]>[],
  copyright: <any[]>[],
  pricePage: [],
});

const skinInitPdf = action(async (val?: string) => {
  const res: any = await Service.getSkin(val);
  // console.log('换肤配置 -- ', res);
  if (res.partner === 'x-giants') {
    document.getElementsByTagName('title')[0].innerText = '人力资源薪酬趋势洞察平台';
  }
  if (res.partner !== 'smartsalary') {
    document.getElementById('consult')?.classList.add('none');
  }
  runInAction(() => {
    moSkinPdf.headerHeight = res.headerHeight || 60;
    moSkinPdf.partner = res.partner || 'smartsalary';
    moSkinPdf.modules = res.modules || [];
    moSkinPdf.logo1 = res.logo1 || '';
    moSkinPdf.logo2 = res.logo2 || '';
    moSkinPdf.hiddenPages = res.hiddenPages || [];
    moSkinPdf.businessPlan = res.pricePage.businessPlan || null;
    moSkinPdf.customReports = res.pricePage.customReports || null;
    moSkinPdf.goldMember = res.pricePage.goldMember || null;
    moSkinPdf.priceCount = res.priceCount || 0;
    moSkinPdf.mainColor = res.mainColor || '';
    moSkinPdf.titleCapColor = res.titleCapColor || '';
    moSkinPdf.counselor = res.counselor || null;
    moSkinPdf.scripts = res.scripts || [];
    moSkinPdf.copyright = res.copyright || [];
    moSkinPdf.pricePage = res.pricePage || [];
  });
});

export default moSkinPdf;
export { skinInitPdf };
